import React from "react";
import { Box, Button, Col, HStack, IDialogInfo, Row, Typography, VStack } from "../../../components";

interface LineItemDeleteModalContentProps {
  onCancel: any;
  onDelete: any;
}

const LineItemDeleteModalContent = ({ onCancel, onDelete }: LineItemDeleteModalContentProps) => {
  return (
    <VStack className="d-flex justify-content-center direction-row px-4">
      <Box className="px-0 pb-4">
        <div className="d-flex direction-col align-items-center">
          <IDialogInfo />
          <Row style={{ justifyContent: "center" }}>
            <Col sm="12" md="10" lg="8">
              <p className="dialog-title">Are you sure you want to delete this item?</p>
              <p className="dialog-description mb-0">
                Once deleted, this item cannot be restored. You will need to add a new line item to your invoice.
              </p>
            </Col>
          </Row>
          <div>
            <div id="mobile-buttons">
              <div className="pb-2">
                <Button className="text-size-18" label="Delete" size="medium" onClick={onDelete} />
              </div>
              <HStack className="pb-2 justify-content-center">
                <Typography onClick={onCancel} className="my-0 text-size-18 text-medium clickable">
                  Cancel
                </Typography>
              </HStack>
            </div>
            <div id="desktop-buttons">
              <Button className="text-size-18" label="Cancel" varient="secondary" size="small" onClick={onCancel} />
              <Button className="text-size-18 ml-8" label="Delete" size="small" onClick={onDelete} />
            </div>
          </div>
        </div>
      </Box>
    </VStack>
  );
};

export default LineItemDeleteModalContent;
